import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { bonusQuestionsRepository } from "@/config/dataSource";
import type { BonusAnswer, BonusQuestionsConfig } from "@/modules/leagues/types/bonusQuestions";

const keys = {
  config: (leagueId: string) => ["bonus-questions-config", leagueId] as const,
  myAnswer: (leagueId: string) => ["bonus-questions-my-answer", leagueId] as const,
};

export function useBonusQuestionsConfig(leagueId: string) {
  return useQuery({
    queryKey: keys.config(leagueId),
    queryFn: () => bonusQuestionsRepository.getConfig(leagueId),
  });
}

export function useSaveBonusQuestionsConfig(leagueId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (config: Pick<BonusQuestionsConfig, "deadline" | "questions">) =>
      bonusQuestionsRepository.saveConfig(leagueId, config),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.config(leagueId) });
    },
  });
}

export function useMyBonusAnswer(leagueId: string) {
  return useQuery({
    queryKey: keys.myAnswer(leagueId),
    queryFn: () => bonusQuestionsRepository.getMyAnswer(leagueId),
  });
}

export function useSaveMyBonusAnswer(leagueId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (answers: BonusAnswer["answers"]) => bonusQuestionsRepository.saveMyAnswer(leagueId, answers),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.myAnswer(leagueId) });
    },
  });
}
